<template>
  <div class="main">
    <div class="try-container">
      <!-- <div class="step1" v-if="step == 1">
        <div class="client">
          <label>客户名称：</label>
          <span>{{name}}</span>
        </div>

        <ul class="cost-list">
          <li class="cost-item" :class="cost==1?'cost-active':''">
            <div class="cost-item-left">
              <em>1</em>
              <span>月</span>
            </div>
            <div class="cost-item-right">
              <span>￥</span>
              <em>399</em>
              <label class="J-radio">
                <input type="radio" name="cost" value="1" checked @change="costChange($event)" />
                <i class="radio-core"></i>
              </label>
            </div>
          </li>
          <li class="cost-item" :class="cost==2?'cost-active':''">
            <div class="cost-item-left">
              <em>2</em>
              <span>月</span>
            </div>
            <div class="cost-item-right">
              <span>￥</span>
              <em>798</em>

              <label class="J-radio">
                <input type="radio" name="cost" value="2" @change="costChange($event)" />
                <i class="radio-core"></i>
              </label>
            </div>
          </li>
          <li class="cost-item" :class="cost==3?'cost-active':''">
            <div class="cost-item-left">
              <em>3</em>
              <span>月</span>
            </div>
            <div class="cost-item-right">
              <span>￥</span>
              <em>1197</em>

              <label class="J-radio">
                <input type="radio" name="cost" value="3" @change="costChange($event)" />
                <i class="radio-core"></i>
              </label>
            </div>
          </li>
        </ul>

        <button class="form-button" type="button" @click="nextClick">下一步</button>
      </div>-->

      <!-- <div class="step2" v-if="step == 2">
        <div class="pay-way">
          <select class="pay-chose" @change="wayChange($event)">
            <option value="1">微信扫码支付</option>
            <option value="2">汇款支付</option>
          </select>
          <div class="pay-content" v-if="way == 1">
            <img class="pay-qr" src="~@/assets/imgs/qr_pay.png" alt />
          </div>
          <div class="pay-content" v-if="way == 2">
            <p>你需汇款至以下账户：</p>
            <p>账号名称：深圳厚科云健康科技有限公司</p>
            <p>开户银行：中国农业银行深圳南山支行</p>
            <p>收款账号：41014100040025712</p>
          </div>
        </div>
        <button class="form-button" type="button" @click="nextClick">下一步</button>
      </div>-->

      <div class="step3">
        <div class="success">
          <svg-icon icon-class="icon_success" class-name="icon_success"></svg-icon>
          <div class="success-title">申请成功</div>
          <div class="success-subtitle">稍后会安排专人跟您联络！</div>
        </div>
        <router-link to="/" exact class="form-button">完成</router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["status"],
  data() {
    return {
      name: this.$route.query.name
    };
  },

  mounted() {
    this.$emit("update:status", false);
    document
      .querySelector("header")
      .setAttribute("style", "background: #213d81");
  },
  beforeDestroy() {
    this.$emit("update:status", true);
    document.querySelector("html").removeAttribute("style");
  }
};
</script>
<style lang='scss' scoped>
.try-container {
  width: 100%;
  background: #fff;
  padding: 96px 32px;
  border-radius: 4px;
  .client {
    font-size: 40px;
    line-height: 56px;
    label {
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
    }
    span {
      color: rgba(0, 0, 0, 0.65);
    }
  }

  .cost-list {
    width: 100%;
    padding: 64px 0;
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    margin-top: 48px;
    .cost-item {
      width: 100%;
      height: 140px;
      padding: 0 32px;
      background: #fcfcfc;
      @include clearfix;
      .cost-item-left {
        float: left;
        height: 140px;
        color: rgba(0, 0, 0, 0.85);
        line-height: 140px;
        em {
          font-size: 60px;
          font-weight: bold;
        }
        span {
          font-size: 28px;
        }
      }
      .cost-item-right {
        float: right;
        height: 140px;
        line-height: 140px;
        color: rgba(0, 0, 0, 0.85);
        span {
          font-size: 28px;
        }
        em {
          font-size: 60px;
          font-weight: bold;
          margin-right: 32px;
        }

        /*radio&&checkbox*/
        .J-radio {
          cursor: pointer;
        }

        .J-radio input[type="radio"] {
          display: none;
        }

        .radio-core:after {
          content: " ";
          border-radius: 50%;
          top: 6px;
          left: 6px;
          position: absolute;
          width: 20px;
          height: 20px;
          transition: transform 0.2s;
          transform: scale(0);
        }

        .J-radio input[type="radio"]:checked + .radio-core:after {
          background-color: #213d81;
          transform: scale(1);
        }

        .radio-core {
          display: inline-block;
          background-color: #fff;
          border-radius: 50%;
          border: 2px solid rgba(0, 0, 0, 0.85);
          position: relative;
          width: 36px;
          height: 36px;
          vertical-align: middle;
          margin-bottom: 24px;
        }
      }
    }
    .cost-active {
      background: #f5f5f5;
      .cost-item-right {
        color: #213d81;
      }
    }
  }
  .pay-way {
    width: 100%;
    padding: 32px;
    .pay-chose {
      display: block;
      width: 292px;
      height: 80px;
      background: rgba(255, 255, 255, 1);
      border-radius: 8px;
      border: 2px solid rgba(0, 0, 0, 0.15);
      font-size: 32px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.65);
      padding: 0 16px;
    }

    .pay-content {
      margin: 32px auto 0;
      width: 100%;
      height: 608px;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 2px solid rgba(0, 0, 0, 0.15);
      padding: 28px;
      .pay-qr {
        width: 100%;
        height: 100%;
      }
      p {
        font-size: 30px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        margin-bottom: 32px;
      }
    }
  }

  .form-button {
    display: block;
    margin: 64px auto 0;
    width: 352px;
    height: 80px;
    border-radius: 8px;
    background: #213d81;
    font-size: 32px;
    font-weight: 400;
    color: #fff;
    text-align: center;
    line-height: 80px;
  }

  .success {
    margin: 68px 0 32px;
    .icon_success {
      display: block;
      width: 176px;
      height: 176px;
      margin: 0 auto;
    }
    .success-title {
      margin-top: 32px;
      text-align: center;
      font-size: 52px;
      color: rgba(0, 0, 0, 0.85);
    }
    .success-subtitle {
      text-align: center;
      font-size: 28px;
      color: rgba(0, 0, 0, 0.45);
      margin: 20px 0 120px;
    }
  }
}
</style>
